const CF_RE = /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\d{3}[A-Za-z]$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const digits = (v) => (v || "").replace(/\D/g, "");
const blank = (v) => !String(v ?? "").trim();
export const validCf = (v) => CF_RE.test((v || "").trim());

// Regole: i formati sbagliati si segnalano subito; i campi obbligatori vuoti dopo il primo «Invia».
const rule = (errors, tried, key, required, value, formatOk, emptyMsg, badMsg) => {
  if (blank(value)) { if (required && tried) errors[key] = emptyMsg; }
  else if (formatOk === false) errors[key] = badMsg;
};

export function activationErrors(f, { tried, isBiz, isMigration, needDoc, hasBill, winetOn, italia }) {
  const e = {};
  const w = winetOn && italia;
  rule(e, tried, "nome", true, f.nome, true, isBiz ? "Inserisci il nome del legale rappresentante" : "Inserisci il nome");
  if (w) rule(e, tried, "cognome", true, f.cognome, true, "Inserisci il cognome");
  if (isBiz) {
    rule(e, tried, "ragione_sociale", true, f.ragione_sociale, true, "Inserisci la ragione sociale");
    rule(e, tried, "piva", true, f.piva, /^\d{11}$/.test((f.piva || "").trim()), "Inserisci la partita IVA", "Servono 11 cifre");
  }
  rule(e, tried, "codice_fiscale", isMigration || w, f.codice_fiscale, validCf(f.codice_fiscale), "Inserisci il codice fiscale", "Codice fiscale non valido (16 caratteri)");
  rule(e, tried, "email", w, f.email, EMAIL_RE.test((f.email || "").trim()), "Inserisci l'email del cliente", "Email non valida");
  rule(e, tried, "telefono", w, f.telefono, digits(f.telefono).length >= 9, "Inserisci il cellulare del cliente", "Numero troppo corto");
  rule(e, tried, "indirizzo", w, f.indirizzo, true, "Inserisci l'indirizzo con numero civico");
  rule(e, tried, "cap", w, f.cap, /^\d{5}$/.test(f.cap || ""), "Inserisci il CAP", "Il CAP ha 5 cifre");
  rule(e, tried, "citta", w, f.citta, true, "Inserisci la città");
  rule(e, tried, "provincia", w, f.provincia, /^[A-Za-z]{2}$/.test(f.provincia || ""), "Inserisci la provincia", "Sigla di 2 lettere");
  rule(e, tried, "piano", true, f.piano, true, "Scegli l'offerta");
  if (needDoc && tried) e.doc = "Carica il documento d'identità del cliente";
  if (isMigration) {
    rule(e, tried, "iccid", true, f.iccid, digits(f.iccid).length >= 18, "Inserisci l'ICCID della SIM attuale", "ICCID troppo corto");
    if (!hasBill && tried) e.bill = "Carica la foto della SIM con l'ICCID visibile";
  }
  if (italia) winetErrors(e, f, tried, w, { isBiz, isMigration });
  return e;
}

function winetErrors(e, f, tried, w, { isBiz, isMigration }) {
  const cfOk = validCf(f.codice_fiscale);
  rule(e, tried, "sim_iccid", w, f.sim_iccid, /^\d{19,20}$/.test(f.sim_iccid || ""), "Inserisci l'ICCID della nuova SIM", "L'ICCID ha 19 o 20 cifre");
  if (w && tried && blank(f.data_nascita) && !cfOk) e.data_nascita = "Inserisci la data di nascita";
  if (w && tried && blank(f.comune_nascita) && blank(f.nazione_nascita) && !cfOk) e.comune_nascita = "Inserisci il comune di nascita";
  if (!blank(f.nazione_nascita) && !/^[A-Z]{3}$/.test(f.nazione_nascita)) e.nazione_nascita = "Codice di 3 lettere, es. ROU";
  rule(e, tried, "doc_tipo", w, f.doc_tipo, true, "Scegli il tipo di documento");
  rule(e, tried, "doc_numero", w, f.doc_numero, true, "Inserisci il numero del documento");
  rule(e, tried, "doc_rilascio", w, f.doc_rilascio, true, "Inserisci la data di rilascio");
  rule(e, tried, "doc_scadenza", w, f.doc_scadenza, true, "Inserisci la data di scadenza");
  if (f.doc_rilascio && f.doc_scadenza && f.doc_scadenza <= f.doc_rilascio) e.doc_scadenza = "La scadenza deve essere dopo il rilascio";
  else if (f.doc_scadenza && f.doc_scadenza < new Date().toISOString().slice(0, 10)) e.doc_scadenza = "Documento scaduto";
  rule(e, tried, "doc_ente", w, f.doc_ente, true, "Inserisci chi ha rilasciato il documento");
  if (isBiz) rule(e, tried, "tipo_azienda", w, f.tipo_azienda, true, "Scegli il tipo di azienda");
  if (isMigration) {
    rule(e, tried, "mnp_numero", w, f.mnp_numero, digits(f.mnp_numero).length >= 9, "Inserisci il numero da portare", "Numero troppo corto");
    rule(e, tried, "mnp_operatore", w, f.mnp_operatore, true, "Indica l'operatore di provenienza");
  }
}

export function rechargeErrors(f, tried) {
  const e = {};
  rule(e, tried, "phone_number", true, f.phone_number, digits(f.phone_number).length >= 9, "Inserisci il numero da ricaricare", "Numero troppo corto");
  rule(e, tried, "importo", true, f.importo, Number(f.importo) > 0, "Inserisci l'importo", "L'importo deve essere maggiore di zero");
  return e;
}

export function infoErrors(f, tried) {
  const e = {};
  if (tried && blank(f.iccid) && blank(f.phone_number)) e.phone_number = "Inserisci l'ICCID o il numero di telefono";
  if (!blank(f.phone_number) && digits(f.phone_number).length < 9) e.phone_number = "Numero troppo corto";
  return e;
}
